
<div class="mat-container">
<div mat-dialog-title>   </div>
<div mat-dialog-content style="text-align: center;">
  You have reached the limit to add new realtors <br>To invite more realtors please upgrade your plan
</div>


<!-- <button type="button"  mat-flat-button>Clear</button> -->
<div mat-dialog-actions class="buttons">
  
<button mat-flat-button mat-dialog-close>Close</button>
    <button type="button" mat-flat-button mat-dialog-close  color="primary" (click)="gotoUpdatePlan()"> Upgrade Plan</button>
    
</div>     

</div>
<!-- <button type="button" (click)="clear()" mat-flat-button>Clear</button>
    <button type="button" (click)="onSubmit()" mat-flat-button color="primary">Save</button> -->